import { Component } from '@angular/core';

@Component({
  selector: 'app-fn-manage-pay-orders',
  templateUrl: './fn-manage-pay-orders.component.html',
  styleUrls: ['./fn-manage-pay-orders.component.scss']
})
export class FnManagePayOrdersComponent {

}
